var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C8.20799e-07 7.61116 7.61116 -8.20798e-07 17 0C26.3888 8.20799e-07 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 -8.20798e-07 26.3888 0 17Z",
    fill: "#FCE000",
    fillOpacity: 0.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17C5 10.3726 10.3726 5 17 5C23.6274 5 29 10.3726 29 17C29 23.6274 23.6274 29 17 29C10.3726 29 5 23.6274 5 17Z",
    fill: "#FCE000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16C17.5523 16 18 16.4477 18 17V23C18 23.5523 17.5523 24 17 24C16.4477 24 16 23.5523 16 23V17C16 16.4477 16.4477 16 17 16Z",
    fill: "#00123A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12Z",
    fill: "#00123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyInfo);
export default __webpack_public_path__ + "static/media/SpyInfo.6a0ec574d1208e62c71f883f972fcc3d.svg";
export { ForwardRef as ReactComponent };